import React, { Component } from "react";
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import mainLogo from'../onctoolkit.png';

class Navigation extends Component {
	render() {
    return (
<div>
<Navbar collapseOnSelect>
  <Navbar.Header pullLeft>
         <a href="https://onctoolkit.com/"><img src={mainLogo} style={{padding:15,width:200}} alt="onctoolkit logo"/></a>
    <Navbar.Toggle />
  </Navbar.Header>
  <Navbar.Collapse>
    <Nav pullRight>
      <NavItem href="https://onctoolkit.com/">Home</NavItem>
    </Nav>
  </Navbar.Collapse>
</Navbar>
</div>
    );
}
}

export default Navigation;
